export const RESERVATION_STATE_VALUES = {
    ON_USE: 1,
    FINALIZED: 2
};
export const RESERVATION_STATES = [
    {
        value: RESERVATION_STATE_VALUES.ON_USE,
        label: "En uso"
    },
    {
        value: RESERVATION_STATE_VALUES.FINALIZED,
        label: "Finalizó"
    }
];
export const MIN_STUDENTS_FOR_A_RESERVATION = 2;
export const TOAST_MESSAGES = {
    SAVE_RESERVATION_STATE: "¡Se cambió exitosamente el estado de la reserva!",
    UPDATE_PENALTY_STUDENT: "¡Se editó exitosamente la sanción del alumno!",
    CANCEL_RESERVATION: "¡Se canceló exitosamente la reserva!",
    SAVE_STUDENT_INFORMATION: "¡Se guardó exitosamente el cambio en la reserva!"
};
export const SPACE_RESERVATION_ERRORS = Object.freeze({
    STUDENT_ALREADY_ADDED: "ALUMNO_YA_AGREGADO",
    UNEXPECTED_ERROR_TO_ADDING: "ERROR_INESPERADO_AL_AGREGAR",
    STUDENTS_WITH_ACTIVE_PENALTY: "ALUMNO_CON_SANCION_ACTIVA",
    STUDENTS_WITH_HOURS_LIMIT_REACHED: "LIMITE_HORAS_ALCANZADO",
    STUDENTS_WITH_SCHEDULE_CROSSING: "CRUCE_HORARIO"
});
export const RESERVATION_DATA_VIEWS = Object.freeze({
    MAIN_VIEW: 0,
    STUDENT_RESERVATION_LIST: 1
});